import { FormDate } from 'components/form/FormDate';
import { Icon } from 'components/Icon';
import { formatDueDate, formatFullDateTime, reminderDuePresets } from 'helpers/entityReminder';
import { React, useMemo, useState } from 'libs/react';
import './DuePresetPicker.scss';
/**
 * @component DuePresetPicker
 * @since 1.0.0
 * Due date as one-click shortcuts, with the full picker one step away. Once
 * chosen, the date collapses into a single removable chip.
 */
export function DuePresetPicker(props) {
    const { value, onChange } = props;
    const [custom, setCustom] = useState(false);
    const presets = useMemo(() => reminderDuePresets(), []);
    if (value && !custom) {
        return (React.createElement("div", { className: "due-preset-picker" },
            React.createElement("span", { className: "due-preset-picker-chip due-preset-picker-chip--selected", title: formatFullDateTime(value) },
                React.createElement(Icon, { className: "due-preset-picker-chip-picto", value: "fal bell" }),
                formatDueDate(value),
                React.createElement("button", { type: "button", className: "due-preset-picker-clear", "aria-label": t('Remove the due date'), onClick: () => onChange(null) },
                    React.createElement(Icon, { value: "fal xmark" })))));
    }
    return (React.createElement("div", { className: "due-preset-picker" }, custom ? (React.createElement("div", { className: "due-preset-picker-custom" },
        React.createElement(FormDate, { name: "due-preset-picker-date", value: value, time: true, minDate: new Date(), onChange: onChange }),
        React.createElement("button", { type: "button", className: "due-preset-picker-chip", disabled: !value, onClick: () => setCustom(false) }, t('OK')))) : (React.createElement(React.Fragment, null,
        presets.map((preset) => (React.createElement("button", { key: preset.key, type: "button", className: "due-preset-picker-chip", title: formatFullDateTime(preset.date), onClick: () => onChange(preset.date.toISOString()) }, preset.label))),
        React.createElement("button", { type: "button", className: "due-preset-picker-chip due-preset-picker-chip--ghost", onClick: () => setCustom(true) },
            React.createElement(Icon, { className: "due-preset-picker-chip-picto", value: "fal calendar" }),
            t('Pick a date…'))))));
}
